(() => {
  const STYLE_ID = 'dtx-hide-dingdoong-notices';
  // DingDoong app block can leave #ot-dingdoong-root empty and render into the embed root.
  const ROOT_SELECTOR =
    '[id^="ot-dingdoong-root"], #dingdoong-embedded-render-root, .ot-dingdoong-main, #dd-container';
  const SCOPE_SELECTOR = `${ROOT_SELECTOR}, .cart-page__more-blocks, .dingdoong-embed-root`;
  const WIDGET_SELECTOR =
    '.ot-dingdoong-calendar, .ot-dingdoong-dropdown, .ot-dingdoong-day-picker-container, .ot-dingdoong-time-picker';
  const SELECTED_SELECTOR =
    '.ot-dingdoong-calendar__selected, .ot-dingdoong-calendar__day.ot-dingdoong-calendar__selected, .ot-dingdoong-calendar__day-button[aria-pressed="true"], .ot-dingdoong-calendar__day-button[aria-selected="true"]';
  // Only hide dedicated notice/message nodes — never structural widget containers.
  const HIDE_SELECTORS = [
    '.ot-dingdoong-required-message',
    '.ot-dingdoong-required-message > div',
    '.ot-dingdoong-additional-message',
    '.ot-dingdoong-header-additional-message',
    '.ot-dingdoong-error-message',
    '.ot-dingdoong-announce-message',
    '.ot-dingdoong-delivery__error-message',
    '.ot-dingdoong-delivery__eligible-message',
    '.ot-dingdoong-earliest-delivery-message',
    '.ot-dingdoong-minimum-order-amount-error',
    '.ot-dingdoong-note-fields__error-message',
    '.ot-dingdoong-error-list-title',
    '.ot-dingdoong-error-list',
    '.dd-text-body-requiredMessage',
    '.dd-custom-message',
  ];
  const STRUCTURAL_SELECTOR = [
    '.shopify-block',
    '.shopify-app-block',
    '.cart-page__more-blocks',
    '.dingdoong-embed-root',
    '.dingdoong-add-block-render-root',
    '#dingdoong-embedded-render-root',
    '[id^="ot-dingdoong-root"]',
    '.ot-dingdoong-main',
    '.ot-dingdoong-header',
    '.ot-dingdoong-day-picker-container',
    '.ot-dingdoong-time-picker-container',
    '.ot-dingdoong-dropdown',
    '.ot-dingdoong-dropdown__button',
    '.ot-dingdoong-dropdown__button-content',
    '.ot-dingdoong-dropdown__content',
    '.ot-dingdoong-dropdown__layer',
    '.ot-dingdoong-calendar',
    '.ot-dingdoong-calendar__popover-button',
    '#dd-container',
    '#fulfillment-method-wrapper',
  ].join(', ');
  const KEEP_VISIBLE_SELECTOR =
    '.ot-dingdoong-calendar, .ot-dingdoong-dropdown, .ot-dingdoong-time-picker, .ot-dingdoong-header__radio, .ot-dingdoong-day-picker-container, .ot-dingdoong-main';
  const PLACEHOLDER_PATTERNS = [
    'data de envio',
    'shipping date',
    'escolha uma data',
    'choose a date',
    'escolha uma data e hora',
    'before checkout',
    'finalização da compra',
  ];
  const CLEAR_DATE_PATTERNS = ['limpar data', 'clear selected', 'clear date', 'clear shipping date'];

  /** @returns {HTMLElement[]} */
  const getDingdoongRoots = () => {
    const nodes = Array.from(document.querySelectorAll(ROOT_SELECTOR)).filter(
      (node) => node instanceof HTMLElement
    );
    const withWidget = nodes.filter((root) => root.querySelector(WIDGET_SELECTOR));
    return withWidget.length ? withWidget : nodes;
  };

  const injectHideStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      [id^="ot-dingdoong-root"] .ot-dingdoong-required-message,
      [id^="ot-dingdoong-root"] .ot-dingdoong-required-message > div,
      [id^="ot-dingdoong-root"] .ot-dingdoong-additional-message,
      [id^="ot-dingdoong-root"] .ot-dingdoong-header-additional-message,
      [id^="ot-dingdoong-root"] .dd-text-body-requiredMessage,
      [id^="ot-dingdoong-root"] .dd-custom-message,
      #dingdoong-embedded-render-root .ot-dingdoong-required-message,
      #dingdoong-embedded-render-root .ot-dingdoong-required-message > div,
      #dingdoong-embedded-render-root .ot-dingdoong-additional-message,
      #dingdoong-embedded-render-root .ot-dingdoong-header-additional-message,
      .cart-page__more-blocks .ot-dingdoong-required-message,
      .cart-page__more-blocks .ot-dingdoong-required-message > div {
        display: none !important;
        visibility: hidden !important;
        height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden !important;
        pointer-events: none !important;
        opacity: 0 !important;
      }
    `;
    document.head.appendChild(style);
  };

  const isCartContext = () =>
    Boolean(
      document.querySelector('#MainContent[data-template="cart"]') ||
        document.querySelector('.dtx-cart-page') ||
        document.body.classList.contains('template-cart')
    );

  /** @param {HTMLElement} node */
  const hideNode = (node) => {
    if (node.matches(STRUCTURAL_SELECTOR)) return;

    node.hidden = true;
    node.setAttribute('aria-hidden', 'true');
    node.style.setProperty('display', 'none', 'important');
    node.style.setProperty('visibility', 'hidden', 'important');
    node.style.setProperty('height', '0', 'important');
    node.style.setProperty('margin', '0', 'important');
    node.style.setProperty('padding', '0', 'important');
    node.style.setProperty('overflow', 'hidden', 'important');
    node.style.setProperty('opacity', '0', 'important');
  };

  /** Restore widget shells that a previous buggy pass may have collapsed. */
  const restoreStructuralNodes = () => {
    document.querySelectorAll(STRUCTURAL_SELECTOR).forEach((node) => {
      if (!(node instanceof HTMLElement)) return;
      // Never force-show nodes the app itself disables (e.g. empty app-block root).
      if (node.id === 'ot-dingdoong-root' && !node.querySelector(WIDGET_SELECTOR)) return;

      if (node.hasAttribute('hidden')) node.removeAttribute('hidden');
      if (node.getAttribute('aria-hidden') === 'true') node.removeAttribute('aria-hidden');

      ['display', 'visibility', 'height', 'margin', 'padding', 'overflow', 'opacity'].forEach((prop) => {
        if (node.style.getPropertyPriority(prop) === 'important') {
          node.style.removeProperty(prop);
        }
      });
    });

    // Ensure the live widget shell is visible when DingDoong rendered into the embed root.
    const main = document.querySelector('#dingdoong-embedded-render-root .ot-dingdoong-main');
    if (main instanceof HTMLElement) {
      main.hidden = false;
      main.removeAttribute('aria-hidden');
      main.style.removeProperty('display');
      main.style.removeProperty('visibility');
      main.style.removeProperty('height');
      main.style.removeProperty('opacity');
    }
  };

  /** @param {ParentNode} root */
  const hideDingdoongCopy = (root) => {
    HIDE_SELECTORS.forEach((selector) => {
      root.querySelectorAll(selector).forEach((node) => {
        if (node instanceof HTMLElement) hideNode(node);
      });
    });

    // Only hide message-like class nodes — do not walk all divs by aggregated textContent
    // (that previously hid .ot-dingdoong-main / .shopify-app-block because children/scripts
    // contained "escolha uma data...").
    root.querySelectorAll('[class*="dingdoong"]').forEach((node) => {
      if (!(node instanceof HTMLElement)) return;
      if (node.matches(STRUCTURAL_SELECTOR)) return;
      if (node.closest(KEEP_VISIBLE_SELECTOR) && !/(message|error|announce|required)/.test(String(node.className).toLowerCase())) {
        return;
      }

      const className = node.className?.toString?.().toLowerCase() || '';
      if (/(message|error|announce|required)/.test(className)) hideNode(node);
    });
  };

  /** @param {ParentNode} root */
  const hasShippingDateSelected = (root) => {
    if (root.querySelector(SELECTED_SELECTOR)) return true;

    // DingDoong only shows the clear control after a date is chosen.
    const clearSelected = Array.from(root.querySelectorAll('button')).some((button) => {
      const label = `${button.textContent || ''} ${button.getAttribute('aria-label') || ''}`.toLowerCase();
      return CLEAR_DATE_PATTERNS.some((pattern) => label.includes(pattern));
    });
    if (clearSelected) return true;

    const button = root.querySelector('.ot-dingdoong-dropdown__button');
    if (!button) return false;

    const text = button.textContent?.trim().toLowerCase() || '';
    if (!text) return false;

    return !PLACEHOLDER_PATTERNS.some((pattern) => text.includes(pattern));
  };

  const isShippingDateSelected = () => {
    const roots = getDingdoongRoots();
    if (!roots.length) return document.querySelector(SELECTED_SELECTOR) != null;
    return roots.some((root) => hasShippingDateSelected(root)) || document.querySelector(SELECTED_SELECTOR) != null;
  };

  const updateNotice = () => {
    const notice = document.querySelector('[data-shipping-date-notice]');
    if (!(notice instanceof HTMLElement)) return;

    const roots = getDingdoongRoots();
    if (!roots.length && !document.querySelector(WIDGET_SELECTOR)) {
      notice.hidden = true;
      notice.removeAttribute('data-shipping-date-missing');
      return;
    }

    if (isShippingDateSelected()) {
      notice.hidden = true;
      notice.removeAttribute('data-shipping-date-missing');
    }
  };

  let syncScheduled = false;

  const sync = () => {
    if (syncScheduled) return;
    syncScheduled = true;

    requestAnimationFrame(() => {
      syncScheduled = false;
      injectHideStyles();
      restoreStructuralNodes();
      document.querySelectorAll(SCOPE_SELECTOR).forEach(hideDingdoongCopy);
      if (isCartContext()) updateNotice();
    });
  };

  const onCheckoutAttempt = (event) => {
    if (!isCartContext()) return;

    const target = event.target;
    if (!(target instanceof Element)) return;

    const trigger =
      target.closest('#checkout, .cart__checkout-button[name="checkout"], [name="checkout"]') ||
      (event instanceof SubmitEvent ? event.submitter : null);

    if (!(trigger instanceof HTMLElement)) return;

    const roots = getDingdoongRoots();
    if (!roots.length && !document.querySelector(WIDGET_SELECTOR)) return;

    if (isShippingDateSelected()) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    sync();

    const notice = document.querySelector('[data-shipping-date-notice]');
    if (notice instanceof HTMLElement) {
      notice.hidden = false;
      notice.toggleAttribute('data-shipping-date-missing', true);
      notice.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      notice.focus();
    }
  };

  injectHideStyles();

  if (isCartContext()) {
    document.addEventListener('click', onCheckoutAttempt, true);
    document.addEventListener('submit', onCheckoutAttempt, true);
    document.addEventListener('change', sync, true);
  }

  sync();

  const obs = new MutationObserver(() => {
    if (isCartContext() || document.querySelector(ROOT_SELECTOR)) sync();
  });

  obs.observe(document.documentElement, {
    subtree: true,
    childList: true,
    characterData: true,
    // Do not watch style/class/hidden — our own hide/restore would loop forever.
  });
})();
